
import { useStore } from '@/store'
import { computed, defineComponent, inject, onMounted, onUnmounted, ref, watch } from 'vue'
import NameConverterService from '@/services/form/name-converter.service'
import nameSettings from '@/settings/name-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingRandselName',
  props: {
    cameraPos: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configNamechar = computed(() => store.getters.configNamechar)
    const configNamethreadId = computed(() => store.getters.configNamethreadId)
    const cameraPos = computed(() => store.getters.cameraPos)
    const height = ref(0)
    let fontChar = ref('')
    let fontSize = ref('100%')
    let fontColor = ref('#000000')
    let containerRef = ref()
    let nameConverterService = new NameConverterService()

    emitter.on('updateConfig', onUpdateConfig)

    function onUpdateConfig() {
      onResizeDelayed()
      updateFont()
    }

    // prettier-ignore
    watch(() => configNamechar.value, (_) => { updateFont() })
    // prettier-ignore
    watch(() => configNamethreadId.value, (_) => { updateFont() })
    // prettier-ignore
    watch(() => cameraPos.value, (_) => { onResizeDelayed() })

    onMounted(() => {
      window.addEventListener('resize', onResize)
    })

    function onResize() {
      updateContainerSize()
      updateFontSize()
    }

    function onResizeDelayed() {
      setTimeout(() => {
        onResize()
      }, 200)
    }

    function updateContainerSize() {
      const h = Math.min(getContainerWidth(), 500)
      height.value = h
      setTimeout(() => {
        height.value = h
      }, 500)

      setTimeout(() => {
        height.value = h
      }, 1500)
    }

    function updateFont() {
      if (props.cameraPos == 0 || props.cameraPos == 2) {
        fontChar.value = ''
        return
      }
      try {
        setTimeout(() => setFont(configNamechar.value, configNamethreadId.value), 200)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
        console.log(err)
      }
    }

    function setFont(namechar: string | null | undefined, namethreadId: string | null | undefined) {
      if (!namechar) {
        fontChar.value = ''
        return
      }
      fontChar.value = nameConverterService.convertToFontMeshCharacters(namechar)
      if (namethreadId) {
        setNameColor(nameSettings.nameitoColors.find((x: any) => x.id == configNamethreadId.value))
      } else {
        setNameColor(nameSettings.nameitoColors.find((x: any) => x.default && x.default === true))
      }
      updateFontSize()
    }

    function setNameColor(obj: any) {
      try {
        fontColor.value = obj.renderingValue
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function updateFontSize() {
      if (fontChar.value.length <= 0 || cameraPos.value != 1) {
        return
      }
      setTimeout(() => {
        const size = (getContainerWidth() / 500) * 100 + '%'
        fontSize.value = size
      }, 300)
    }

    function getContainerWidth() {
      const container = containerRef.value as HTMLCanvasElement
      if (!container) {
        console.log('HTMLCanvasElement is null ?!')
        return 0
      }
      return container.clientWidth
    }

    onUnmounted(() => {
      window.removeEventListener('resize', onResize)
      emitter.off('updateConfig', onUpdateConfig)
    })

    return {
      height,
      containerRef,
      fontChar,
      fontColor,
      fontSize
    }
  }
})
